if (!customElements.get('product-price')) {
	customElements.define('product-price', class ProductPrice extends HTMLElement {
		constructor() {
			super();
		}

		update(price, compareAtPrice, noConvert = false) {
      // 1) Mise à jour des datasets si l’élément est utilisé comme "price-scope"
      //    Par défaut, si on ne connaît pas HT vs TTC, on aligne les deux sur "price".
      if (this.hasAttribute('data-price-scope') || this.dataset.priceScope !== undefined) {
        if (!this.dataset.priceHt)  this.dataset.priceHt  = String(price || 0);
        if (!this.dataset.priceTtc) this.dataset.priceTtc = String(price || 0);

        // compare
        if (!this.dataset.compareHt)  this.dataset.compareHt  = String(compareAtPrice || 0);
        if (!this.dataset.compareTtc) this.dataset.compareTtc = String(compareAtPrice || 0);
      }

      const hasPair = !!this.querySelector('[data-price-pair]');

      // Helpers format
      const fmt = (cents) => Shopify.showPrice(parseInt(cents || 0, 10), noConvert);
      const setPriceWithTaxNote = (el, value) => {
        if (!el) return;
        const taxNote = el.querySelector('.price-tax-note');
        if (taxNote) {
          const note = taxNote.cloneNode(true);
          el.innerHTML = value;
          el.append(note);
          return;
        }
        el.innerHTML = value;
      };

      // 2) On met à jour par "role" si on a un pair HT/TTC
      if (hasPair) {
        const pair = this.querySelector('[data-price-pair]');
        const blocks = [
          { role: 'ht',  priceKey: 'priceHt',  compareKey: 'compareHt' },
          { role: 'ttc', priceKey: 'priceTtc', compareKey: 'compareTtc' }
        ];

        blocks.forEach(({ role, priceKey, compareKey }) => {
          const scope = pair.querySelector(`[data-role="${role}"]`);
          if (!scope) return;

          const rolePrice = parseInt(this.dataset[priceKey] || price || 0, 10);
          const roleCompare = parseInt(this.dataset[compareKey] || compareAtPrice || 0, 10);

          const onSale = roleCompare > rolePrice;

          // classe sale au niveau racine (si au moins un role est en promo)
          if (onSale) this.classList.add('price--on-sale');

          // Regular / Sale à l’intérieur du role
          const regular = scope.querySelector('.price__regular .price-item--regular');
          const sale    = scope.querySelector('.price-item--sale');
          if (regular) setPriceWithTaxNote(regular, fmt(rolePrice));
          if (sale)    setPriceWithTaxNote(sale, fmt(rolePrice));

          // Compare at price (dans .price__sale)
          const saleWrap = scope.querySelector('.price__sale');
          if (saleWrap) {
            let compareEl = saleWrap.querySelector('.price-item--regular');
            if (!compareEl) {
              const spanPrice = document.createElement('span');
              const sPrice = document.createElement('s');
              sPrice.className = 'price-item price-item--regular light';
              spanPrice.append(sPrice);
              saleWrap.prepend(spanPrice);
              compareEl = sPrice;
            }
            compareEl.innerHTML = fmt(roleCompare);
          }
        });

        // si aucun role n’est en promo, on nettoie la classe
        const htPrice  = parseInt(this.dataset.priceHt  || price || 0, 10);
        const htComp   = parseInt(this.dataset.compareHt || compareAtPrice || 0, 10);
        const ttcPrice = parseInt(this.dataset.priceTtc || price || 0, 10);
        const ttcComp  = parseInt(this.dataset.compareTtc || compareAtPrice || 0, 10);
        if (!(htComp > htPrice) && !(ttcComp > ttcPrice)) {
          this.classList.remove('price--on-sale');
        }

        return;
      }

      // 3) Fallback ancien (un seul prix)
      const onSale = compareAtPrice > price;
      if (onSale) this.classList.add('price--on-sale');
      else this.classList.remove('price--on-sale');

      const priceText = fmt(price);
      const compareAtPriceText = fmt(compareAtPrice);

      this.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(priceTag => {
        setPriceWithTaxNote(priceTag, priceText);
      });

      const saleWrap = this.querySelector('.price__sale');
      if (saleWrap) {
        let compareEl = saleWrap.querySelector('.price-item--regular');
        if (!compareEl) {
          const spanPrice = document.createElement('span');
          const sPrice = document.createElement('s');
          sPrice.className = 'price-item price-item--regular light';
          spanPrice.append(sPrice);
          saleWrap.prepend(spanPrice);
          compareEl = sPrice;
        }
        compareEl.innerHTML = compareAtPriceText;
      }
    }
	});
}
